﻿import Page_ from "./components/Page";
import DefaultEdit_ from "./components/DefaultEdit";
import DefaultSearchBox_ from "./components/DefaultSearchBox";
import DefaultSearchBoxExtension_ from "./components/DefaultSearchBoxExtension";
import DefaultTransfertSearchBoxes_ from "./components/DefaultTransfertSearchBoxes";
import DonneesReferentielles_ from "./components/DonneesReferentielles";
import SecuriteUtilisateurEdit_ from "./components/SecuriteUtilisateurEdit";
import AssocierDesMunicipalitesAuSyndicatSpecialise_ from "./components/AssocierDesMunicipalitesAuSyndicatSpecialise";
import PanneauAdministration_ from "./components/PanneauAdministration";
import SommaireTacheAdministrative_ from "./components/SommaireTacheAdministrative";
import FermeAdditionSommaireActions_ from "./components/FermeAdditionSommaireActions";
import FermeAdditionSommaireIdentification_ from "./components/FermeAdditionSommaireIdentification";
import FermeAdditionSommaireMapaq_ from "./components/FermeAdditionSommaireMapaq";
import GestionPersonneFerme_ from "./components/GestionPersonneFerme";
import SommairePersonnes_ from "./components/SommairePersonnes";
import SommairePersonne_ from "./components/SommairePersonne";
import FduGenererLiens_ from "./components/FduGenererLiens";
import FermeSommaireFluxDeTravaux_ from "./components/FermeSommaireFluxDeTravaux";
import DefaultWorkflowStep_ from "./components/DefaultWorkflowStep";
import DefaultNotes_ from "./components/DefaultNotes";

declare function require(module: string): unknown;
// Generique
const Page = require("./components/Page") as Page_;
const DefaultEdit = require("./components/DefaultEdit") as DefaultEdit_;
const DefaultSearchBox = require("./components/DefaultSearchBox") as DefaultSearchBox_;
const DefaultSearchBoxExtension = require("./components/DefaultSearchBoxExtension") as DefaultSearchBoxExtension_;
const DefaultTransfertSearchBoxes = require("./components/DefaultTransfertSearchBoxes") as DefaultTransfertSearchBoxes_;
// Specifique
const DonneesReferentielles = require("./components/DonneesReferentielles") as DonneesReferentielles_;
const SecuriteUtilisateurEdit = require("./components/SecuriteUtilisateurEdit") as SecuriteUtilisateurEdit_;
const AssocierDesMunicipalitesAuSyndicatSpecialise = require("./components/AssocierDesMunicipalitesAuSyndicatSpecialise") as AssocierDesMunicipalitesAuSyndicatSpecialise_;
const PanneauAdministration = require("./components/PanneauAdministration") as PanneauAdministration_;
const SommaireTacheAdministrative = require("./components/SommaireTacheAdministrative") as SommaireTacheAdministrative_;
const FermeAdditionSommaireActions = require("./components/FermeAdditionSommaireActions") as FermeAdditionSommaireActions_;
const FermeAdditionSommaireIdentification = require("./components/FermeAdditionSommaireIdentification") as FermeAdditionSommaireIdentification_;
const FermeAdditionSommaireMapaq = require("./components/FermeAdditionSommaireMapaq") as FermeAdditionSommaireMapaq_;
const GestionPersonneFerme = require("./components/GestionPersonneFerme") as GestionPersonneFerme_;
const SommairePersonnes = require("./components/SommairePersonnes") as SommairePersonnes_;
const SommairePersonne = require("./components/SommairePersonne") as SommairePersonne_;
const FduGenererLiens = require("./components/FduGenererLiens") as FduGenererLiens_;
const FermeSommaireFluxDeTravaux = require("./components/FermeSommaireFluxDeTravaux") as FermeSommaireFluxDeTravaux_;
const DefaultWorkflowStep = require("./components/DefaultWorkflowStep") as DefaultWorkflowStep_;
const DefaultNotes = require("./components/DefaultNotes") as DefaultNotes_;

export = {
    //== Generic components
    Page,
    DefaultEdit,
    DefaultSearchBox,
    DefaultSearchBoxExtension,
    DefaultTransfertSearchBoxes,
    DefaultNotes,
    //== Custom components
    DonneesReferentielles,
    SecuriteUtilisateurEdit,
    AssocierDesMunicipalitesAuSyndicatSpecialise,
    PanneauAdministration,
    SommaireTacheAdministrative,
    FermeSommaireFluxDeTravaux,
    DefaultWorkflowStep,
    FermeAdditionSommaireActions,
    FermeAdditionSommaireIdentification,
    FermeAdditionSommaireMapaq,
    SommairePersonnes,
    SommairePersonne,
    GestionPersonneFerme,
    FduGenererLiens
};